// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__3M1zZ","productName":"Table_productName__1X4ZM"};